var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path3, _rect13, _path4, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 24,
    viewBox: "0 0 124 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 18.4615,
    transform: "matrix(1 0 0 -1 0 22.1538)",
    fill: "#323507"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2836,
    height: 18.4615,
    transform: "matrix(1 0 0 -1 0.925781 22.1538)",
    fill: "#787813"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.77612,
    height: 18.4615,
    transform: "matrix(1 0 0 -1 0.925781 22.1538)",
    fill: "#FCFF62"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.77612,
    height: 18,
    transform: "matrix(1 0 0 -1 5.55176 21.6924)",
    fill: "#FCFF62"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.77612,
    height: 18,
    transform: "matrix(1 0 0 -1 14.8057 21.6924)",
    fill: "#FCFF62"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.77612,
    height: 18,
    transform: "matrix(1 0 0 -1 10.1787 21.6924)",
    fill: "#FCFF62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.925781 2.76904L0.925781 3.69212L22.2094 3.69212V2.76904L0.925781 2.76904Z",
    fill: "#323507"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.925781 22.1538L0.925781 23.0769L22.2094 23.0769V22.1538L0.925781 22.1538Z",
    fill: "#323507"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 18.4615,
    transform: "matrix(1 0 0 -1 22.209 22.1538)",
    fill: "#323507"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0299,
    height: 15.2308,
    transform: "matrix(1 0 0 -1 5.55176 16.1538)",
    fill: "#FCFF62"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0299,
    height: 0.923078,
    transform: "matrix(1 0 0 -1 5.55176 16.1538)",
    fill: "#323507"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0299,
    height: 0.923077,
    transform: "matrix(1 0 0 -1 5.55176 15.231)",
    fill: "#787813"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.85075,
    height: 12.4615,
    transform: "matrix(1 0 0 -1 17.582 13.3848)",
    fill: "#FCFF62"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1.85075,
    height: 13.3846,
    transform: "matrix(1 0 0 -1 3.70117 14.3076)",
    fill: "#FCFF62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32829 2.53857H9.25366V3.46165H10.179V4.38473H11.1044V5.30781H12.0298V4.38473H12.9552V3.46165H13.8805V2.53857H14.8059H16.6566V11.7693H14.8059V8.07704H13.8805V7.15396H12.9552V8.07704H12.0298V9.00011H11.1044V8.07704H10.179V7.15396H9.25366V8.07704H8.32829V11.7693H6.47754V2.53857H8.32829Z",
    fill: "#323507"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 19.8462,
    transform: "matrix(1 0 0 -1 2.77637 20.769)",
    fill: "#323507"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70117 0L3.70117 0.923076L19.4325 0.923077V6.85932e-07L3.70117 0Z",
    fill: "#323507"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 19.8462,
    transform: "matrix(1 0 0 -1 19.4326 20.769)",
    fill: "#323507"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923079,
    transform: "matrix(1 0 0 -1 18.5078 20.769)",
    fill: "#323507"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923079,
    transform: "matrix(1 0 0 -1 3.70117 20.769)",
    fill: "#323507"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923077,
    transform: "matrix(1 0 0 -1 4.62695 15.231)",
    fill: "#323507"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923077,
    transform: "matrix(1 0 0 -1 4.62695 14.3076)",
    fill: "#787813"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923077,
    transform: "matrix(1 0 0 -1 3.70117 14.3076)",
    fill: "#323507"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923077,
    transform: "matrix(1 0 0 -1 17.582 15.231)",
    fill: "#323507"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923077,
    transform: "matrix(1 0 0 -1 17.582 14.3076)",
    fill: "#787813"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925373,
    height: 0.923077,
    transform: "matrix(1 0 0 -1 18.5078 14.3076)",
    fill: "#323507"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70117 20.769L3.70117 21.6921L19.4325 21.6921V20.769L3.70117 20.769Z",
    fill: "#323507"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6089_3907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.195 4.89208H106.843V5.86131H107.49V6.83054H108.137V7.79977H108.785V8.76901H109.432V3.92285H112.67V20.0767H109.432V19.1075H108.785V18.1382H108.137V17.169H107.49V16.1998H106.843V15.2305H106.195V20.0767H102.958V3.92285H106.195V4.89208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6249 4.56901H36.2723V5.21516H36.9197V5.86131H37.5672V6.50747H38.2146V5.86131H38.862V5.21516H39.5095V4.56901H40.1569V3.92285H43.3941V20.0767H40.1569V12.6459H39.5095V11.9998H38.862V12.6459H38.2146V13.2921H37.5672V12.6459H36.9197V11.9998H36.2723V12.6459H35.6249V20.0767H32.3877V3.92285H35.6249V4.56901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5799 4.56901H60.2274V5.21516H60.8748V5.86131H61.5222V6.50747H62.1697V5.86131H62.8171V5.21516H63.4646V4.56901H64.112V3.92285H67.3492V20.0767H64.112V12.6459H63.4646V11.9998H62.8171V12.6459H62.1697V13.2921H61.5222V12.6459H60.8748V11.9998H60.2274V12.6459H59.5799V20.0767H56.3428V3.92285H59.5799V4.56901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7242 7.15362H48.8973V7.79977H48.2499V9.73824H48.8973V10.3844H54.7242V13.6152H48.8973V14.2613H48.2499V16.1998H48.8973V16.8459H54.7242V20.0767H45.0127V3.92285H54.7242V7.15362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6793 7.15362H72.8524V7.79977H72.2049V9.73824H72.8524V10.3844H78.6793V13.6152H72.8524V14.2613H72.2049V16.1998H72.8524V16.8459H78.6793V20.0767H68.9678V3.92285H78.6793V7.15362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.339 7.15362H95.5125V7.79977H94.8651V9.73824H95.5125V10.3844H101.339V13.6152H95.5125V14.2613H94.8651V16.3613H95.5125V16.8459H101.339V20.0767H91.6279V3.92285H101.339V7.15362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.535 16.3613H84.1825V16.8459H90.0094V20.0767H80.2979V3.92285H83.535V16.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.41 3.92285V4.56901H122.057V5.21516H122.705V5.86131H123.352V6.50747H124V17.4921H123.352V18.1382H122.705V18.7844H122.057V19.4305H121.41V20.0767H114.288V3.92285H121.41ZM118.173 7.15362V7.79977H117.525V16.1998H118.173V16.8459H120.115V16.1998H120.762V7.79977H120.115V7.15362H118.173Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6089_3907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.6119,
    height: 16.1538,
    fill: "white",
    transform: "translate(32.3877 3.92285)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.835b8df6161789004781ce4b4a54d77c.svg";
export { ForwardRef as ReactComponent };